export default {
  dbu_user_data_center_title: '你的DataBrain MBTI',
  dbu_user_data_center_subtitle: '你在 DataBrain 的季度探索足迹与专属数据画像',
};
